import { render } from "./InquiryIndex.vue?vue&type=template&id=2a2fb250&scoped=true"
import script from "./InquiryIndex.vue?vue&type=script&lang=js"
export * from "./InquiryIndex.vue?vue&type=script&lang=js"

import "./InquiryIndex.vue?vue&type=style&index=0&id=2a2fb250&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2fb250"]])

export default __exports__